import { SourceInterface } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { Message } from "../../../js/parsegenerated";
import { getMessageType } from "../helpers/helpers";

export const useExcelExportData = () => {
  const t = useTranslation();

  function exportTableData(
    tableData: Message[],
    selectedSource: SourceInterface
  ) {
    const filename = t("maintenance:export.excel.file.name", {
      source: selectedSource.name,
    });
    const mappedData = tableData.map(messageToExcelData);
    const sheet = XLSX.utils.json_to_sheet(mappedData);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      book,
      sheet,
      t("maintenance:export.excel.sheet")
    );
    XLSX.writeFile(book, filename + ".xlsx");
  }

  function messageToExcelData(message: Message) {
    const prefix = "maintenance:export.excel.file.cols.";
    const obj = {};
    obj[t(prefix + "date")] = dayjs(message.get("displayAt")).format(
      "DD.MM.YYYY HH:mm:ss"
    );
    obj[t(prefix + "type")] = t(
      "maintenance:export.excel.file.attr." + getMessageType(message)
    );
    obj[t(prefix + "title")] = t(
      message?.get("title"),
      message?.data?.translation
    );
    obj[t(prefix + "description")] = t(
      message?.get("content"),
      message?.data?.translation
    );
    return obj;
  }

  return {
    exportTableData,
  };
};
